import { createContext } from "react";

export const BannersContext = createContext()
export const BannersFormContext = createContext()
export const BannersReportContext = createContext()